import { useRoute } from "next/router";
import Head from "next/head";
import "../../static/css/app.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default (props) => {
  const router = useRoute();

  const { pathname } = router;

  let favicon = "../../static/images/UPS_Favicon.ico";
  let title = "Unified Products and Services";

  if (pathname === "ecashpay-kyc") {
    favicon = "../../static/images/Ecashpay_favicon.ico";
    title = "Ecashpay Asia Inc.";
  }

  return (
    <div>
      <Head>
        <link rel="shortcut icon" href={favicon} />
        <title>{title}</title>
        <link
          rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.0/css/bootstrap.min.css"
          integrity="sha384-9gVQ4dYFwwWSjIDZnLEWnxCjeSWFphJiwGPXr1jddIhOegiu1FwO5qRGvFXOdJZ4"
          crossOrigin="anonymous"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i"
        />
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v5.0.12/css/all.css"
          integrity="sha384-G0fIWCsCzJIMAVNQPfjH08cyYaUtMwjJwqiRKxxE/rx96Uroj1BtIQ6MLJuheaO9"
          crossOrigin="anonymous"
        />
        {/* <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests"/> */}
      </Head>
      <div>{props.children}</div>
    </div>
  );
};



// WEBPACK FOOTER //
// components/template/Layout.js